import { 健康保険被保険者区分, 介護保険被保険者区分 } from "./types"

function calculate第2号被保険者の月間介護保険料(
  標準報酬月額: number,
  労使折半する前の介護保険料率: number,
  健康保険被保険者区分: 健康保険被保険者区分,
): number {
  if (健康保険被保険者区分 === "国民健康保険") return 0; // 国保の介護分は別ルート（所得割）で扱う想定
  return Math.floor((標準報酬月額 * 労使折半する前の介護保険料率) / 2);
}

function calculate第1号被保険者の月間介護保険料(
  市区町村ごとの基準額: number,
  所得段階ごとの乗数: number,
): number {
  return Math.floor(市区町村ごとの基準額 * 所得段階ごとの乗数);
}

/**
 * 初日年齢: 対象月1日時点の満年齢（socialInsuranceEngine では calculateAge(対象年, 対象月, 1, 生年月日)）
 */
export function calculate月間介護保険料(
  初日年齢: number,
  健康保険被保険者区分: 健康保険被保険者区分, //全員入力必須
  医療保険に加入しているか: boolean,
  判定月の月末時点で日本に住民票があるか: boolean,
  適用除外施設に入所しているか: boolean,
  標準報酬月額: number,
  労使折半する前の介護保険料率: number,
  市区町村ごとの基準額: number,
  所得段階ごとの乗数: number,
): { 介護保険被保険者区分: 介護保険被保険者区分; 月間介護保険料: number } {

  // 1. 住民票・施設・医療保険（第2号の前提。第1号は別制度だが、入力不足時は 0 に寄せる）
  if (!判定月の月末時点で日本に住民票があるか || 適用除外施設に入所しているか || !医療保険に加入しているか) return {
    介護保険被保険者区分: "介護保険被保険者ではない",
    月間介護保険料: 0,
  };

  // 2. 満年齢（対象月1日時点）。生年月日は呼び出し側で初日年齢に集約済み。
  if (初日年齢 >= 65) {
    return {
      介護保険被保険者区分: "介護保険第1号被保険者",
      月間介護保険料: calculate第1号被保険者の月間介護保険料(市区町村ごとの基準額, 所得段階ごとの乗数),
    };
  }

  if (初日年齢 >= 40) {
    return {
      介護保険被保険者区分: "介護保険第2号被保険者",
      月間介護保険料: calculate第2号被保険者の月間介護保険料(標準報酬月額, 労使折半する前の介護保険料率, 健康保険被保険者区分),
    };
  }

  return {
    介護保険被保険者区分: "介護保険被保険者ではない",
    月間介護保険料: 0,
  };
}
